export default () => ({
  registratieStats: [],
  rapportages: []
});
